var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.canceledDriver !== null)?_c('small',[_c('strong',[_vm._v(_vm._s(_vm.canceledDriver.default_car ? _vm.canceledDriver.default_car.indicativ : 'xxx'))]),_vm._v(": "+_vm._s(this.order.cancellation_reason_text.split('~')[1])+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }